const jsCookie = require('js-cookie');
const _ = require('lodash');
const $ = require("jquery");

let initialized = false;

class UTMCookies {
  constructor() {
    // Cookie algorithm
    this.FIRST_UTM_COOKIE = 'dpi_utmOrigVals';
    this.UTM_COOKIE = 'dpi_utmVals';
    this.EXPIRATION = 730;

    if (initialized) {
      return;
    }

    initialized = true;

    const currentCookieExists = !!jsCookie.get(this.UTM_COOKIE);
    if (!currentCookieExists) {
      this.setUtmCookieToDirect();
    }

    const hasReferrer = (
      document.referrer &&
      document.referrer !== '' &&
      new URL(document.referrer).hostname !== 'iterable.com'
    );
    if (hasReferrer) {
      const searchEngine = this.getSearchEngine(document.referrer);

      jsCookie.set(
        this.UTM_COOKIE,
        JSON.stringify({
          UTM_Medium__c: searchEngine ? 'organic' : 'referral',
          UTM_Source__c: (
            this.getSearchEngine(document.referrer) || document.referrer
          ),
          UTM_Campaign__c: 'not set',
          UTM_Content__c: 'not set',
          UTM_Term__c: 'not set',
          GCLID__c: 'not set',
          icid: 'not set'
        }),
        { expires: this.EXPIRATION }
      );
    }

    const searchParams = new URLSearchParams(window.location.search);
    const hasUrlUTMs = _.some(
      ['utm_medium', 'utm_source', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'icid'],
      key => searchParams.has(key)
    );
    if (hasUrlUTMs) {
      jsCookie.set(
        this.UTM_COOKIE,
        JSON.stringify({
          UTM_Medium__c: searchParams.has('utm_medium') ? searchParams.get('utm_medium') : 'not set',
          UTM_Source__c: searchParams.has('utm_source') ? searchParams.get('utm_source') : 'not set',
          UTM_Campaign__c: searchParams.has('utm_campaign') ? searchParams.get('utm_campaign') : 'not set',
          UTM_Content__c: searchParams.has('utm_content') ? searchParams.get('utm_content') : 'not set',
          UTM_Term__c: searchParams.has('utm_term') ? searchParams.get('utm_term') : 'not set',
          GCLID__c: searchParams.has('gclid') ? searchParams.get('gclid') : 'not set',
          icid: searchParams.has('icid') ? searchParams.get('icid') : 'not set'
        }),
        { expires: this.EXPIRATION }
      );
    }

    const firstCookieExists = !!jsCookie.get(this.FIRST_UTM_COOKIE);
    if (!firstCookieExists) {
      jsCookie.set(
        this.FIRST_UTM_COOKIE,
        JSON.stringify(_.mapKeys(
          JSON.parse(jsCookie.get(this.UTM_COOKIE)),
          (value, key) => `First_${key}`
        )),
        { expires: this.EXPIRATION }
      );
    }

    // On form submit
    document.addEventListener('itbl.demo_form_submit', () => {
      const firstCookieExists = !!jsCookie.get(this.FIRST_UTM_COOKIE);
      if (firstCookieExists) {
        this.setUtmCookieToDirect();
      }
    });
  }

  setUtmCookieToDirect() {
    jsCookie.set(
      this.UTM_COOKIE,
      JSON.stringify({
        UTM_Medium__c: 'website',
        UTM_Source__c: 'direct',
        UTM_Campaign__c: 'not set',
        UTM_Content__c: 'not set',
        UTM_Term__c: 'not set',
        GCLID__c: 'not set',
        icid: 'not set'
      }),
      { expires: this.EXPIRATION }
    );
  }

  initForm(form, isMarketoForm) {
    if (!form) {
      return;
    }

    // Add UTM values to the form as hidden input fields
    [this.FIRST_UTM_COOKIE, this.UTM_COOKIE].forEach(cookieName => {
      const cookieStr = jsCookie.get(cookieName);

      if (!cookieStr) {
        return;
      }

      const cookie = JSON.parse(cookieStr);
      if (cookie) {
        Object.entries(cookie).forEach(([key, val]) => {
          if (val === 'Direct') {
            if (key === 'UTM_Medium__c' || key === 'First_UTM_Medium__c') {
              val = 'website';
            } else if (key === 'UTM_Source__c' || key === 'First_UTM_Source__c') {
              val = 'direct';
            }
          }

          if (val === 'NULL' || val === '') {
            val = 'not set';
          }

          if (['UTM_Source__c', 'First_UTM_Source__c'].includes(key)) {
            switch (val) {
              case "Google": {
                val = val.toLowerCase();
                break;
              }

              case "Yahoo Search": {
                val = "yahoo";
                break;
              }

              case "Microsoft Bing": {
                val = "bing";
                break;
              }
            }
          }

          if (isMarketoForm) {
            const field = { [key]: val };
            form.vals(field);
            form.addHiddenFields(field);
          } else {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = val;
            form.appendChild(input);
          }
        });
      }
    });

    // We need to prevent double initialization of the form
    if (
      isMarketoForm ||
      !(form.hasAttribute('data-digitalpi-utms-added'))
    ) {
      if (isMarketoForm) {
        form.vals({ 'data-digitalpi-utms-added': true })
      } else {
        form.setAttribute('data-digitalpi-utms-added', true);
      }
    }
  }

  getSearchEngine(referrer) {
    return {
      "google.com": "google",
      "bing.com": "bing",
      "yahoo.com": "yahoo",
      "baidu.com": "Baidu",
      "duckduckgo.com": "DuckDuckGo",
      "yandex.com": "Yandex",
      "ask.com": "Ask",
      "naver.com": "Naver",
      "aol.com": "AOL",
      "seznam.cz": "Seznam",
      "yippy.com": "Yippy",
      "a9.com": "Amazon A9",
      "openverse.com": "OpenVerse (CC Search)",
      "gibiru.com": "Gibiru",
      "searchencrypt.com": "Search Encrypt",
      "searx.me": "Searx",
      "startpage.com": "StartPage",
      "swisscows.com": "Swisscows",
      "ecosia.org": "Ecosia",
      "gigablast.com": "Gigablast",
      "lycos.com": "Lycos",
      "mojeek.com": "Mojeek",
      "neeva.com": "Neeva",
      "qmamu.com": "Qmamu",
      "wolframalpha.com": "WolframAlpha",
      "webcrawler.com": "WebCrawler",
      "metager.org": "MetaGer",
      "qwant.com": "Qwant",
      "you.com": "You",
      "oscobo.co.uk": "Oscobo",
      "infinitysearch.co": "Infinity Search",
      "yep.com": "YEP",
      "anoox.com": "Anoox",
    }[_.replace(new URL(referrer).hostname || '', 'www.', '')];
  }
}

UTMCookies.init = () => {
  $(document).ready(function () {
    $('.itbl-b-form, .itbl-activate-hub-page-events-save-the-date-form, [data-component="whitepaper_form_form"], [data-component="roi_calculator_form_form"], [data-component="form1262"]').each(
      (i, e) => {
        const utmCookies = new UTMCookies();
        utmCookies.initForm(e, false);
      }
    );

    if (!window.MktoForms2) {
      console.error('MktoForms2 is not defined')
      return;
    }

    const forms = window.MktoForms2.allForms()

    if (forms.length) {
      forms.forEach(form => {
        const utmCookies = new UTMCookies();
        utmCookies.initForm(form, true);
      });
    }
  });
}

module.exports = UTMCookies;
